import type { CSSProperties } from 'react'

interface FeaturedCategoryArrowIconProps {
    className?: string
    style?: CSSProperties
}

export default function FeaturedCategoryArrowIcon({ className, style }: FeaturedCategoryArrowIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            className={className}
            style={style}
            aria-hidden
        >
            <path
                d="M2.5 6H9.5M6 9.5L9.5 6L6 2.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
